export default class FormatService {
    static format(lead) {
        Object.keys(lead).forEach(index => {
            if (lead[index] == null || lead[index] == undefined || lead[index] === '') {
                delete lead[index];
            }
        });

        if ("price" in lead) {
            delete lead.price;
        }

        if ("busy" in lead) {
            delete lead.busy;
        }

        if ("birth_year" in lead) {
            delete lead.birth_year;
        }

        if ("premium_carrier" in lead) {
            delete lead.premium;
        }

        if ("premium_price" in lead) {
            delete lead.carrier;
        }

        if ("status_title" in lead) {
            delete lead.status_title;
        }

        if ("user_id" in lead) {
            delete lead.user_id;
        }

        if ("birth_month" in lead) {
            delete lead.birth_month;
        }

        if ("birth_day" in lead) {
            delete lead.birth_day;
        }

        if ("fname" in lead) {
            delete lead.fname;
        }

        if ("lname" in lead) {
            delete lead.lname;
        }

        if ("status_title" in lead) {
            delete lead.status_title;
        }

        if ("created" in lead) {
            delete lead.created;
        }

        if ("agent_fullname" in lead) {
            delete lead.agent_fullname;
        }

        if ("agent_email" in lead) {
            delete lead.agent_email;
        }

        if ("pc" in lead) {
            delete lead.pc;
        }

        if ("post_sale" in lead) {
            delete lead.post_sale;
        }

        if ("type_id" in lead) {
            delete lead.type_id;
        }

        return lead;
    }
}
